/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */



/* ============= Tab =============  */
document.addEventListener('DOMContentLoaded', function(){	
	const tabs = document.getElementsByClassName('tab');
	for(let i = 0; i < tabs.length; i++) {
		tabs[i].addEventListener('click', tabSwitch);
	}
	function tabSwitch(){	
		const ancestorEle = this.closest('.tab-panel');		
		ancestorEle.getElementsByClassName('is-active')[0].classList.remove('is-active');
		this.classList.add('is-active');		
		ancestorEle.getElementsByClassName('is-show')[0].classList.remove('is-show');
		const groupTabs = ancestorEle.getElementsByClassName('tab');
		const arrayTabs = Array.prototype.slice.call(groupTabs);
		const index = arrayTabs.indexOf(this);
		ancestorEle.getElementsByClassName('panel')[index].classList.add('is-show');
	};
});


/* ============= MegaMenu Collection =============  */
const menuCategoryLink = document.querySelectorAll(".MegaMenuCategory__Tab .Item");
const menuCategoryItem = Array.prototype.slice.call(menuCategoryLink,0);
menuCategoryItem.forEach(function (element) {
	element.addEventListener("mouseover",function(){
		const ItemList = document.querySelectorAll(".MegaMenuCategory__Content .Item__Wrap");     
		for(let i = 0; i < ItemList.length; i++) {
			ItemList.item(i).classList.remove("active");
		}    
		const attrValue = element.dataset.item;
		const target = document.getElementById("category-tab" + attrValue );
		target.classList.add("active");            
	},false);
});

  
                 
/* ============= MobileMenuCategory =============  */
const menuCategoryMobile = document.querySelectorAll(".mobile-menu__nav .category-item-collapsible");
function toggle() {
	const content = this.nextElementSibling;
	this.classList.toggle("is-active");
	content.classList.toggle("is-open");
}
for (let i = 0; i < menuCategoryMobile.length; i++) {
	menuCategoryMobile[i].addEventListener("click", toggle);
}

/* ============= MobileMenu =============  */
const menuNaviMobile = document.querySelectorAll(".c-mobile-menu__nav-link");
function toggle() {
	const content = this.nextElementSibling;
	this.classList.toggle("is-active");
	content.classList.toggle("is-open");
}
for (let i = 0; i < menuNaviMobile.length; i++) {
	menuNaviMobile[i].addEventListener("click", toggle);
}


/* ============= Header Search: empty query → /collections/all =============  */
document.addEventListener('DOMContentLoaded', function () {
	document.querySelectorAll('.header__search-bar-wrapper .search-bar').forEach(function (form) {
		form.addEventListener('submit', function (event) {
			var input = form.querySelector('[name="q"]');
			if (input && input.value.trim() === '') {
				event.preventDefault();
				event.stopImmediatePropagation();
				window.location.href = '/collections/all';
			}
		}, true);
	});
});
